import { useCallback, useEffect, useMemo, useState } from 'react';

import sendRequest from '../../../service/sendRequest';
import callApi from '../../../service/callApi';
import arrayToContainerOptions from '../utils/arrayToContainerOptions';

const useAIMediaOptions = ({ search }) => {
  const [localOptions, setLocalOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const searchedOptions = useMemo(() => {
    return localOptions?.filter((option) => option.label.toLowerCase().includes(search.toLowerCase()));
  }, [localOptions, search]);

  const handleLoadAIMedia = useCallback(async () => {
    setIsLoading(true);

    const response = await sendRequest(() => callApi.get('/api/ai/playground/media/types'));
    const options = arrayToContainerOptions(response.data);
    setLocalOptions(options);

    setIsLoading(false);
  }, []);

  useEffect(() => {
    handleLoadAIMedia();
  }, [handleLoadAIMedia]);

  return { options: searchedOptions, isLoading };
};

export default useAIMediaOptions;
